import { useEffect } from 'react';

import { getSocket } from '#client';

export const useSocketIo = <T>({ event, onEvent }: { event: string; onEvent: (data: T) => void }) => {
  const socket = getSocket();

  useEffect(() => {
    socket.on(event, onEvent);

    return () => {
      socket.off(event, onEvent);
    };
  }, [socket, event, onEvent]);
};
